import { render, staticRenderFns } from "./ToSModal.vue?vue&type=template&id=5d37ab72&scoped=true"
import script from "./ToSModal.vue?vue&type=script&lang=ts"
export * from "./ToSModal.vue?vue&type=script&lang=ts"
import style0 from "./ToSModal.vue?vue&type=style&index=0&id=5d37ab72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d37ab72",
  null
  
)

export default component.exports